import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_n6syjm4y9g: FaireBrandEntity = {
  token: "b_n6syjm4y9g",
  type: "brand",
  name: "Marulin Limited",
  avatarUrl:
    "https://cdn.faire.com/fastly/e00d14adb017dd3dcae865cd7d7a8b55a69632426613a06f0c553219055f6219.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/a14c303e3fc87070fc975da67a45bef36796760a2432058ae3671ebb0c02d718.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/e00d14adb017dd3dcae865cd7d7a8b55a69632426613a06f0c553219055f6219.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a14c303e3fc87070fc975da67a45bef36796760a2432058ae3671ebb0c02d718.jpeg",
  location: "London, GBR",
  minimumOrderDollars: 202,
  rating: 0,
  reviewCount: 0,
  isInsider: false,
  description:
    "Hello! We are CJ and Tim, the folks behind Marulin.  \nTim and I met in the United Kingdom over afternoon tea – no joke! Tim was a finance guy, and I was a scientist with a family in tea.  I had grown up drinking oolong tea from our gardens. \n\nWe created Marulin to share the teas from our farms and friends with the world.\n\nMarulin is an independent tea company based in London and supplies premium teas and accessories to tea businesses and hospitality throughout the UK, Europe, USA and Kenya. \n\nOur tea heritage extends from four generations of family tea farming in Nantou, Taiwan. As a family of tea producers, makers, and masters, we care about the communities that bring tea to you. Having our teas will bring you on a little journey with each sip.  \n\nThe company’s in-depth knowledge of tea allows it to provide specialised tea products and offer complimentary training to B2B customers.  Marulin brings over 60 finest teas and infusions from our family and friends gardens to the world.  \n",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:48.828Z",
    importedBy: "entity-db-cli",
  },
};
